import { Component, OnInit } from '@angular/core';
import { Company } from '../domain/company';
import { CompanyService } from '../service/company.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HostListener } from '@angular/core';

@Component({
    templateUrl: './company-edit.component.html',
    host: {
    '(document:keypress)': 'handleKeyboardEvent($event)'
    }
})
export class CompanyEditComponent implements OnInit {

    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.keyCode == 27)
        {
            this.cancel();
        }
        if (event.keyCode == 13)
        {
            this.saveAndClose();
        }
    }

    pageTitle: string;
    id: string;
    object: Company = new Company();
    isDisabled: boolean = false; 

    constructor(
        private route: ActivatedRoute,
        private CompanyService: CompanyService,
        private router: Router
    ) {
        this.id = this.route.snapshot.paramMap.get('id');

        if (this.id === 'new') {
            this.pageTitle = "New company:";
            this.object = new Company();
        } else {
            this.pageTitle = "Edit company:";
            this.CompanyService
                .getById(this.id)
                .then(company => (this.object = company));
        }
    }

    ngOnInit() {}

    save() {
        this.isDisabled=true;
        if (this.id === 'new') {
            this.CompanyService
            .post(this.object)
            .then(companyData => this.router.navigate(['/companies/' + companyData.id]))
            .then(data=>{
                this.reloadCompany();
                this.isDisabled=false;
            })
            .catch(error => {
                this.reloadCompany();
                this.isDisabled=false;
               
            }); 
        }else{
            this.CompanyService
            .put(this.object, this.id)
            .then(companyData => this.router.navigate(['/companies/' + companyData.id]))
            .then(data=>{
                this.isDisabled=false;
            })
            .catch(error => {
                this.isDisabled=false;
            }); 
        }
  
    }

    saveAndClose() {
        this.isDisabled=true;
        if (this.id === 'new') {
            this.CompanyService
            .post(this.object)
            .then(data=>{
                this.router.navigate(['/companies'])
                this.isDisabled=false;
            })
            .catch(error => {
                this.reloadCompany();
                this.isDisabled=false;
               
            }); 
        }else{
            this.CompanyService
            .put(this.object, this.id)
            .then(() => this.router.navigate(['/companies']))
            .then(data=>{
                this.isDisabled=false;
            })
            .catch(error => {
                this.isDisabled=false;
            }); 
        }

        
       
    }

    cancel() {
        this.router.navigate(['/companies']);
    }
    reloadCompany(){
        if (this.id === 'new') {
            this.pageTitle = "New company:";
            this.object = new Company();
        } else {
            this.pageTitle = "Edit company:";
            this.CompanyService
                .getById(this.id)
                .then(company => (this.object = company));
        }
    }
}
